export const loadMapbox = () => import('mapbox-gl')
